<template>
  <light-theme>
    <div v-if="quotes.length && !completed">
      <div class="share-box">
        <div class="top-heading">
          <p>Curated For</p>
          <h3 v-if="clientData">{{clientData.attributes.firstName}} {{clientData.attributes.lastName}}</h3>
        </div>
        <p v-if="quotes.length>1">{{ slideNumber + 1 }} of {{ quotes.length }}</p>
        <hooper ref="carousel" :settings="hooperSettings" @slide="updateSlide">
          <slide v-for="(quote, index) in quotes" :key="index">
            <div class="share-item">
              <img v-if="quote.attributes.images.length" :src="quote.attributes.images[0].url" />
              <h4 class="font-weight-bold">{{ quote.attributes.brand }}</h4>
              <p class="font-weight-light font-size-15">{{ quote.attributes.name }}</p>
              <p class="font-weight-bold bold-color">${{ quote.attributes.buyoutQuote }}</p>
              <p class="font-weight-light font-size-11">would you like to sell this item?</p>
              <div v-on:click="userSelection( $event, quote, index)">
                <button
                  class="btn btn-outline mr-2"
                  :class="{ active: quote.activeItem === 'buyout'}"
                  id="buyout"
                >Yes</button>
                <button
                  class="btn btn-outline mr-2"
                  :class="{ active: quote.activeItem === 'rejected'}"
                  id="rejected"
                >No</button>
                <!-- <button class="btn btn-outline" :class="{ active: quote.activeItem === 'save'}" id="save">Save <i class="fa fa-heart"></i></button> -->
              </div>
            </div>
          </slide>
          <navigation v-if="quotes.length>1" slot="hooper-addons">
            <i class="fas fa-chevron-left" slot="hooper-prev"></i>
            <i class="fas fa-chevron-right" slot="hooper-next"></i>
          </navigation>
        </hooper>
      </div>
      <light-footer
        :clientData="stylistData"
        :buttonText="'confirm quotes'"
        :validated="productSelection.length>0"
        @prchaseAction="confirmAction"
      ></light-footer>
    </div>
    <div v-else-if="completed" class="share-box">
      <p class="pt-5 text-center">
        Thanks, {{ clientData.attributes.firstName }}! Your Quotes are now confirmed. We will notify your stylist {{ stylistData[0].attributes.name }} immediately.
      </p>
    </div>
    <div v-else class="share-box">
      <p v-if="clientData" class="pt-5 text-center">Sorry, {{ clientData.attributes.firstName }}, there are no quotes to review at this time.</p>
    </div>
  </light-theme>
</template>
<script>
import LightTheme from '../layouts/light'
import { Hooper, Slide, Navigation } from 'hooper'
import LightFooter from '@/components/shared/light-footer'
import api from '@/services/api'
export default {
  data () {
    return {
      nextClass: 'disabled',
      prevClass: '',
      slideNumber: 0,
      hooperSettings: {
        infiniteScroll: false,
        itemsToShow: 1.2,
        centerMode: true,
        itemsToSlide: 1
      },
      quotes: [],
      buttonDisabled: false,
      productSelection: [],
      stylistData: [],
      clientData: null,
      completed: false,
      isLoadingQuotes: false
    }
  },
  components: {
    LightFooter,
    LightTheme,
    Hooper,
    Slide,
    Navigation
  },
  methods: {
    updateSlide (slide) {
      this.slideNumber = slide.currentSlide
    },
    getQuotes () {
      // Prevent duplicate calls
      if (this.isLoadingQuotes) {
        return
      }

      this.isLoadingQuotes = true

      api
        .get(
          '/api/client/' + this.apiRoute + '/' + this.$route.params.id
        )
        .then(response => {
          // Ensure quotes is always an array
          const responseData = response.data.data
          let rawQuotes = []

          if (Array.isArray(responseData)) {
            rawQuotes = responseData
          } else if (responseData && typeof responseData === 'object') {
            // If it's an object, try to extract an array from it
            rawQuotes = responseData.data || Object.values(responseData)
          }

          // Normalize quotes to ensure consistent structure
          this.quotes = rawQuotes.map(quote => {
            // If quote already has attributes, return as is
            if (quote.attributes) {
              return quote
            }
            // Otherwise, wrap it in attributes for consistent template rendering
            return {
              id: quote.id,
              attributes: quote
            }
          })

          this.getDetails(response.data.meta)
          this.isLoadingQuotes = false
        })
        .catch(err => {
          console.error('Error fetching quotes:', err)
          this.quotes = []
          this.isLoadingQuotes = false
        })
    },
    getDetails (meta) {
      api
        .get(
          '/api/account?include=stylist'
        )
        .then(res => {
          if (res.data && res.data.data) {
            const { data, included } = res.data
            const clientId = data.id
            this.clientData = data
            this.stylistData = included.filter(item => item.id !== clientId)
          }
        })
        .catch(err => {
          console.error('Error fetching details:', err)
        })
    },
    userSelection: function (e, quoteItem, index) {
      const pendingItem = this.quotes.filter(
        item => item.id === quoteItem.id
      )[0]
      const filterDataIndex =
        this.productSelection &&
        this.productSelection.findIndex(res => res.id === pendingItem.id)
      filterDataIndex === -1
        ? this.productSelection.push({
          id: pendingItem.id,
          clientResponse: e.target.id
        })
        : (this.productSelection[filterDataIndex].clientResponse = e.target.id)
      this.buttonDisabled =
        this.productSelection &&
        this.productSelection.some(element => {
          return element.clientResponse === 'buyout'
        })
      this.quotes = this.quotes.map(element => {
        if (element.id === pendingItem.id) {
          element.activeItem = e.target.id
        }
        return element
      })
    },
    confirmAction () {
      const data = JSON.stringify({
        pendingItems: this.productSelection
      })
      const form = new FormData()
      form.append('data', data)
      api
        .post(
          '/api/client/' + this.apiRoute + '/' + this.$route.params.id,
          form
        )
        .then(res => {
          this.completed = true
          if (res.data) {
            this.buttonDisabled = false
          }
        })
    }
  },
  mounted: function () {
    this.getQuotes()
  },
  watch: {
    slideNumber () {
      this.$refs.carousel.slideTo(this.slideNumber)
    },
    '$route' (to, from) {
      // Only reload quotes if the route params actually changed
      if (to.params.id !== from.params.id) {
        this.quotes = []
        this.getQuotes()
      }
    },
    'apiRoute' (newVal, oldVal) {
      // Only reload if apiRoute actually changed
      if (newVal !== oldVal && oldVal !== undefined) {
        this.quotes = []
        this.getQuotes()
      }
    }
  },
  computed: {
    apiRoute () {
      return this.$route.name
    }
  }
}
</script>
<style>
.hooper-slide .share-item {
  background: #fff;
  padding: 20px;
  margin: 10px;
  min-height: 600px;
}

.hooper-navigation {
  font-size: 24px;
}

.hooper-next {
  right: -50px !important;
}

.hooper-prev {
  left: -50px !important;
}
</style>
